import { render, staticRenderFns } from "./beneficiary-bt-bank-name.vue?vue&type=template&id=6ce53ec8&"
import script from "./beneficiary-bt-bank-name.vue?vue&type=script&lang=js&"
export * from "./beneficiary-bt-bank-name.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports